/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserCouponCodes200ResponseAllOfData } from './GetUserCouponCodes200ResponseAllOfData';
import {
    GetUserCouponCodes200ResponseAllOfDataFromJSON,
    GetUserCouponCodes200ResponseAllOfDataFromJSONTyped,
    GetUserCouponCodes200ResponseAllOfDataToJSON,
} from './GetUserCouponCodes200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserCouponCodes200Response
 */
export interface GetUserCouponCodes200Response {
    /**
     * 
     * @type {GetUserCouponCodes200ResponseAllOfData}
     * @memberof GetUserCouponCodes200Response
     */
    data: GetUserCouponCodes200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetUserCouponCodes200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetUserCouponCodes200Response interface.
 */
export function instanceOfGetUserCouponCodes200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetUserCouponCodes200ResponseFromJSON(json: any): GetUserCouponCodes200Response {
    return GetUserCouponCodes200ResponseFromJSONTyped(json, false);
}

export function GetUserCouponCodes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCouponCodes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserCouponCodes200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetUserCouponCodes200ResponseToJSON(value?: GetUserCouponCodes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserCouponCodes200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

